import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const yesItems = ['Tenés ganas de aprender un oficio que te dé independencia real', 'Ya trabajás con hierro, madera o herramientas y querés monetizarlo', 'Estás cansado de depender de un sueldo que no te alcanza', 'Querés emprender pero necesitás un sistema concreto, no teoría', 'Tenés poco tiempo y necesitás resultados rápidos', 'Sos principiante total y querés aprender desde cero con orden'];
const noItems = ['Buscás hacerte rico sin trabajar ni aprender nada', 'No estás dispuesto a ensuciarte las manos aunque sea un poco', 'Esperás resultados sin aplicar lo que el manual te enseña', 'Querés un negocio que funcione solo sin ningún esfuerzo de tu parte'];
export function ForWhomSection() {
  return <section className="py-20 px-4 bg-brand-gray" data-id="element-145">
      <div className="max-w-4xl mx-auto" data-id="element-146">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-12" data-id="element-147">
          ¿Este manual es para vos?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-148">
          {/* YES */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-brand-green/20" data-id="element-149">
            <h3 className="text-2xl font-black text-brand-green mb-6" data-id="element-150">
              ✅ SÍ es para vos si...
            </h3>
            <ul className="space-y-4" data-id="element-151">
              {yesItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-152">
                  <CheckCircleIcon className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" data-id="element-153" />
                  <span className="text-gray-800 font-medium" data-id="element-154">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* NO */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-red-200" data-id="element-155">
            <h3 className="text-2xl font-black text-red-600 mb-6" data-id="element-156">
              ❌ NO es para vos si...
            </h3>
            <ul className="space-y-4" data-id="element-157">
              {noItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-158">
                  <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-159" />
                  <span className="text-gray-800 font-medium" data-id="element-160">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}